module.exports = __webpack_public_path__ + "static/media/pin.79a81008.svg";